import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'qbPhone',
    standalone: false
})
export class PhonePipe implements PipeTransform {
    // pattern looks like: 'dd-ddd-ddd'
    transform(phone: string | undefined, pattern: string | undefined, separator: string | undefined, maxLength = 300): string {

        if (!phone) return '';
        if (!separator) separator = '-';
        if (!pattern) return phone;

        if (phone.length > maxLength) {
            phone = phone.substr(0, maxLength);
        }

        const result = pattern.split('').map((val) => { return val === separator ? separator : undefined; });
        phone = phone.trim().split(separator).join('');

        const separatorSpaceArray = [];
        let countNonSeparatorSymbols = 0;
        for (let i = 0; i < pattern.length; i++) {
            if (pattern[i] != separator)
                countNonSeparatorSymbols++;
            else {
                separatorSpaceArray.push(countNonSeparatorSymbols);
                countNonSeparatorSymbols = 0;
            }
        }
        separatorSpaceArray.push(countNonSeparatorSymbols + 1);
        separatorSpaceArray.reduce((pv, v, index, separatorSpaceArray) => {
            separatorSpaceArray[index] = pv + v;
            return pv + v + 1;
        });

        let lengthFinded = false;
        if (phone.length < maxLength) {
            for (let i = 0; i < separatorSpaceArray.length && !lengthFinded; i++) {
                if (separatorSpaceArray[i] > phone.length) {
                    result.length = separatorSpaceArray[i];
                    lengthFinded = true;
                }
            }
        }

        for (let phoneCounter = 0, resultCounter = 0; resultCounter < result.length; resultCounter++) {
            if (result[resultCounter] == undefined) {
                result[resultCounter] = phone[phoneCounter];
                phoneCounter++;
            }
        }

        return result.join('').slice(0, maxLength);
    }
}